/* src/app/candidate-form/view-document-dialog/view-document-dialog.component.scss */
.view_document_body {
  padding: 15px;
}
